export default "__VITE_ASSET__5Eaq5J67__"